import IItemOrderStatusViewModel from "interfaces/IItemOrderStatusViewModel";
import { ReactComponent as Clothing } from "assets/itemorderIcons/Clothing.svg";
import { ReactComponent as Equipment } from "assets/itemorderIcons/Equipment.svg";
import { ReactComponent as Other } from "assets/itemorderIcons/Other.svg";
import { ItemOrderStatusEnum } from "modules/ItemOrderStatusEnum";

const OrderItemTemplate = ({ status, orderType }: IItemOrderStatusViewModel): any => {
  const isStatusTerminal = () : boolean => [ItemOrderStatusEnum.Abandoned, ItemOrderStatusEnum.Received].includes(status as ItemOrderStatusEnum);

  const getIcon = () => {
    let icon : JSX.Element;
    const iconSize : number = 32;

    switch (orderType) {
      case "Clothing":
        icon = <Clothing width={iconSize} height={iconSize} />;
        break;
      case "Equipment":
        icon = <Equipment width={iconSize} height={iconSize} />;
        break;
      default:
        icon = <Other width={iconSize} height={iconSize} />;
        break;
    }

    return <span className={`item-order-icon ${isStatusTerminal() ? "item-order-complete" : "item-order-active"}`}>{icon}</span>;
  };

  return (
    <>
      {getIcon()}
      <span className="fw-bold">{orderType}</span>
    </>
  );
};

export default OrderItemTemplate;
